import React, { useEffect, useState } from 'react';
import SelectBox from '../base_components/SelectBox.tsx';
import { Control, FieldErrors } from 'react-hook-form';
import staticDataService from '../../api_handlers/services/StaticDataService.ts';

interface IQuestionTypeProps {
  control: Control<any>;
  errors: FieldErrors<any>;
}

interface Option {
  key: number | string;
  value: string;
}

const TeamSelectBox = ({ control, errors }: IQuestionTypeProps) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState<boolean>(true); 
  const [error, setError] = useState<string | null>(null);
  console.log("🚀 ~ TeamSelectBox ~ error:", error)

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        var data = await staticDataService.fetchTeams();
        console.log(data.data);
        setOptions(data.data);
        setLoading(false); 
      } catch (err) {
        setError('Failed to load teams');
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  return (
    <SelectBox
      name="teams"
      id="slboxTeam"
      control={control}
      errors={errors}
      label="Teams"
      defaultValue=""
      required={true}
      options={loading ? [{ key: '', value: 'Loading...' }] : options} // Show loading text
      disabled={loading} // Disable SelectBox while loading or if there's an error
    />
  );
};

export default TeamSelectBox;
